var popup = {
    sa: {},
    info: {},
    plugin_name: 'WebPopup',
    lib_version: '1.25.20',
    plugin_version: '1.25.20',
    defaultPara: { platform: 'H5', preload_image: !0, encrypt_cookie: !1 },
    serverData: {},
    localData: {
      global_popup_count: [],
      local_update_time: null,
      eventQueue: [],
      update_time: null
    },
    eventRule: {},
    convertPlans: [],
    isRun: !1,
    setArg: function (t) {
      var e = {}
      if (t && '[object Object]' === Object.prototype.toString.call(t)) {
        for (var n in t) n && 'popup_window_content' !== n && (e[n] = t[n])
        return JSON.stringify(e, null, '  ')
      }
      return t
    },
    log: function () {
      if (
        !0 === popup.info.show_log &&
        'object' == typeof console &&
        'function' == typeof console.log
      )
        try {
          return (
            (arguments[0] = popup.setArg(arguments[0])),
            (arguments[1] = popup.setArg(arguments[1])),
            console.log.apply(console, arguments)
          )
        } catch (t) {
          console.log(arguments[0])
        }
    },
    config: {
      storageName: 'sensorsdata202002-webpopupdata',
      loadedSign: 'SensorsData2015JSSDKWebPopupIsLoad'
    }
  },
  _ = {
    visibility: function (t) {
      t = t || {}
      var e = {
        hidden: undefined,
        visibilityChange: undefined,
        isSupported: function () {
          return 'undefined' != typeof this.hidden
        },
        _visible: t.onVisible,
        _hidden: t.onHidden,
        _nativeSwitch: function () {
          !0 === document[this.hidden] ? this._hidden() : this._visible()
        },
        listen: function () {
          try {
            this.isSupported()
              ? document.addEventListener(
                  this.visibilityChange,
                  function () {
                    e._nativeSwitch.apply(e, arguments)
                  },
                  1
                )
              : document.addEventListener
              ? (window.addEventListener('focus', this._visible, 1),
                window.addEventListener('blur', this._hidden, 1))
              : (document.attachEvent('onfocusin', this._visible),
                document.attachEvent('onfocusout', this._hidden))
          } catch (t) {}
        },
        init: function () {
          'undefined' != typeof document.hidden
            ? ((this.hidden = 'hidden'),
              (this.visibilityChange = 'visibilitychange'))
            : 'undefined' != typeof document.mozHidden
            ? ((this.hidden = 'mozHidden'),
              (this.visibilityChange = 'mozvisibilitychange'))
            : 'undefined' != typeof document.msHidden
            ? ((this.hidden = 'msHidden'),
              (this.visibilityChange = 'msvisibilitychange'))
            : 'undefined' != typeof document.webkitHidden &&
              ((this.hidden = 'webkitHidden'),
              (this.visibilityChange = 'webkitvisibilitychange')),
            this.listen()
        }
      }
      e.init()
    },
    getRgba: function (t) {
      return 'object' != typeof t
        ? t
        : 'rgba(' + t.r + ',' + t.g + ',' + t.b + ',' + t.a + ')'
    },
    conversionNum: function (t) {
      if (t) {
        if (/^[0|1]?\.\d+$/.test(t)) return 100 * Number(t) + '%'
        var e = /^(-?\d+(\.\d+)?)px$/.exec(t)
        return e
          ? ((Number(e[1]) / 375) * window.screen.width).toFixed(2) + 'px'
          : t
      }
    },
    boxModel: function (t) {
      return function (e) {
        if ('object' != typeof e) return t + ':' + e + ';'
        var n = ''
        for (var p in e) n += t + '-' + p + ':' + _.conversionNum(e[p]) + ';'
        return n
      }
    },
    localStorage: {
      get: function (t) {
        return window.localStorage.getItem(t)
      },
      parse: function (t) {
        var e = null
        try {
          e = JSON.parse(_.localStorage.get(t)) || null
        } catch (n) {}
        return e
      },
      set: function (t, e) {
        window.localStorage.setItem(t, e)
      },
      remove: function (t) {
        window.localStorage.removeItem(t)
      },
      isSupport: function () {
        var t = !0
        try {
          var e = '__sensorsdatasupport__',
            n = 'testIsSupportStorage'
          _.localStorage.set(e, n),
            _.localStorage.get(e) !== n && (t = !1),
            _.localStorage.remove(e)
        } catch (p) {
          t = !1
        }
        return t
      }
    },
    addEvent: function () {
      function t(e) {
        return (
          e &&
            ((e.preventDefault = t.preventDefault),
            (e.stopPropagation = t.stopPropagation),
            (e._getPath = t._getPath)),
          e
        )
      }
      ;(t._getPath = function () {
        var t = this
        return (
          this.path ||
          (this.composedPath && this.composedPath()) ||
          (function () {
            try {
              var e = t.target,
                n = [e]
              if (null === e || null === e.parentElement) return []
              for (; null !== e.parentElement; )
                (e = e.parentElement), n.unshift(e)
              return n
            } catch (p) {
              return []
            }
          })()
        )
      }),
        (t.preventDefault = function () {
          this.returnValue = !1
        }),
        (t.stopPropagation = function () {
          this.cancelBubble = !0
        })
      ;(function (e, n, p) {
        if (e && e.addEventListener)
          e.addEventListener(
            n,
            function (e) {
              ;(e._getPath = t._getPath), p.call(this, e)
            },
            !1
          )
        else {
          var o = 'on' + n,
            i = e[o]
          e[o] = (function (e, n, p) {
            return function (o) {
              if (!(o = o || t(window.event))) return undefined
              o.target = o.srcElement
              var i,
                a,
                r = !0
              return (
                'function' == typeof p && (i = p(o)),
                (a = n.call(e, o)),
                (!1 !== i && !1 !== a) || (r = !1),
                r
              )
            }
          })(e, p, i)
        }
      }.apply(null, arguments))
    },
    extend: function (t) {
      var e = Array.prototype.slice
      return (
        _.each(e.call(arguments, 1), function (e) {
          for (var n in e) void 0 !== e[n] && (t[n] = e[n])
        }),
        t
      )
    },
    extend2Lev: function (t) {
      return (
        _.each(Array.prototype.slice.call(arguments, 1), function (e) {
          for (var n in e)
            void 0 !== e[n] &&
              (_.isObject(e[n]) && _.isObject(t[n])
                ? _.extend(t[n], e[n])
                : (t[n] = e[n]))
        }),
        t
      )
    },
    each: function (t, e, n) {
      var p = Object.prototype.hasOwnProperty,
        o = Array.prototype.forEach,
        i = {}
      if (null == t) return !1
      if (o && t.forEach === o) t.forEach(e, n)
      else if (t.length === +t.length) {
        for (var a = 0, r = t.length; a < r; a++)
          if (a in t && e.call(n, t[a], a, t) === i) return !1
      } else
        for (var s in t)
          if (p.call(t, s) && e.call(n, t[s], s, t) === i) return !1
    },
    xhr: function (t) {
      if (t)
        return 'undefined' != typeof window.XMLHttpRequest &&
          'withCredentials' in new XMLHttpRequest()
          ? new XMLHttpRequest()
          : 'undefined' != typeof XDomainRequest
          ? new XDomainRequest()
          : null
      if ('undefined' != typeof window.XMLHttpRequest)
        return new XMLHttpRequest()
      if (window.ActiveXObject)
        try {
          return new ActiveXObject('Msxml2.XMLHTTP')
        } catch (e) {
          try {
            return new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {}
        }
    },
    ajax: function (t) {
      function e(t) {
        if (!t) return ''
        try {
          return JSON.parse(t)
        } catch (e) {
          return {}
        }
      }
      ;(t.timeout = t.timeout || 2e4),
        (t.credentials = 'undefined' == typeof t.credentials || t.credentials)
      var n = _.xhr(t.cors)
      if (!n) return !1
      t.type || (t.type = t.data ? 'POST' : 'GET')
      var p,
        o = (t = _.extend(
          { success: function () {}, error: function () {} },
          t
        )).success,
        i = t.error
      ;(t.success = function (t) {
        o(t), p && (clearTimeout(p), (p = null))
      }),
        (t.error = function (t) {
          i(t), p && (clearTimeout(p), (p = null))
        }),
        (p = setTimeout(function () {
          !(function () {
            try {
              _.isObject(n) && n.abort && n.abort()
            } catch (e) {
              sd.log(e)
            }
            p &&
              (clearTimeout(p),
              (p = null),
              t.error && t.error(),
              (n.onreadystatechange = null),
              (n.onload = null),
              (n.onerror = null))
          })()
        }, t.timeout)),
        'undefined' != typeof XDomainRequest &&
          n instanceof XDomainRequest &&
          ((n.onload = function () {
            t.success && t.success(e(n.responseText)),
              (n.onreadystatechange = null),
              (n.onload = null),
              (n.onerror = null)
          }),
          (n.onerror = function () {
            t.error && t.error(e(n.responseText), n.status),
              (n.onreadystatechange = null),
              (n.onerror = null),
              (n.onload = null)
          })),
        (n.onreadystatechange = function () {
          try {
            4 == n.readyState &&
              ((n.status >= 200 && n.status < 300) || 304 == n.status
                ? t.success(e(n.responseText))
                : t.error(e(n.responseText), n.status),
              (n.onreadystatechange = null),
              (n.onload = null))
          } catch (p) {
            ;(n.onreadystatechange = null), (n.onload = null)
          }
        }),
        n.open(t.type, t.url, !0)
      try {
        t.credentials && (n.withCredentials = !0),
          _.isObject(t.header) &&
            _.each(t.header, function (t, e) {
              n.setRequestHeader && n.setRequestHeader(e, t)
            }),
          t.data &&
            (t.cors ||
              (n.setRequestHeader &&
                n.setRequestHeader('X-Requested-With', 'XMLHttpRequest')),
            'application/json' === t.contentType
              ? n.setRequestHeader &&
                n.setRequestHeader(
                  'Content-type',
                  'application/json; charset=UTF-8'
                )
              : n.setRequestHeader &&
                n.setRequestHeader(
                  'Content-type',
                  'application/x-www-form-urlencoded'
                ))
      } catch (a) {
        sd.log(a)
      }
      n.send(t.data || null)
    },
    getUuid: function () {
      var t = function () {
        return Math.random().toString(16).replace('.', '')
      }
      return function () {
        var e =
          (function () {
            for (var t = 1 * new Date(), e = 0; t == 1 * new Date(); ) e++
            return t.toString(16) + e.toString(16)
          })() +
          '-' +
          t() +
          '-' +
          t()
        return (
          e ||
          (
            String(Math.random()) +
            String(Math.random()) +
            String(Math.random())
          ).slice(2, 15)
        )
      }
    },
    trim: function (t) {
      return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
    },
    isEmptyObject: function (t) {
      var e = Object.prototype.hasOwnProperty
      if (_.isObject(t)) {
        for (var n in t) if (e.call(t, n)) return !1
        return !0
      }
      return !1
    },
    filter: function (t, e, n) {
      var p = Object.prototype.hasOwnProperty
      if (t.filter) return t.filter(e)
      for (var o = [], i = 0; i < t.length; i++)
        if (p.call(t, i)) {
          var a = t[i]
          e.call(n, a, i, t) && o.push(a)
        }
      return o
    },
    isObject: function (t) {
      return null != t && '[object Object]' == Object.prototype.toString.call(t)
    },
    getConvertNumberValue: function (t) {
      return _.isString(t) && (t = Number(t)), Math.floor(1e3 * t) / 1e3
    },
    isArray:
      Array.isArray ||
      function (t) {
        return '[object Array]' === Object.prototype.toString.call(t)
      },
    isString: function (t) {
      return '[object String]' == Object.prototype.toString.call(t)
    },
    isDate: function (t) {
      return '[object Date]' == Object.prototype.toString.call(t)
    },
    isBoolean: function (t) {
      return '[object Boolean]' == Object.prototype.toString.call(t)
    },
    isNumber: function (t) {
      return (
        '[object Number]' == Object.prototype.toString.call(t) &&
        /[\d\.]+/.test(String(t))
      )
    },
    isFunction: function (t) {
      if (!t) return !1
      var e = Object.prototype.toString.call(t)
      return '[object Function]' == e || '[object AsyncFunction]' == e
    },
    getURLSearchParams: function (t) {
      for (
        var e = function (t) {
            return decodeURIComponent(t)
          },
          n = {},
          p = (t = t || '').substring(1).split('&'),
          o = 0;
        o < p.length;
        o++
      ) {
        var i = p[o].indexOf('=')
        if (-1 !== i) {
          var a = p[o].substring(0, i),
            r = p[o].substring(i + 1)
          ;(a = e(a)), (r = e(r)), (n[a] = r)
        }
      }
      return n
    },
    URL: function (t) {
      var e,
        n = {},
        p = [
          'hash',
          'host',
          'hostname',
          'href',
          'origin',
          'password',
          'pathname',
          'port',
          'protocol',
          'search',
          'username'
        ]
      if (
        'function' == typeof window.URL &&
        (function () {
          try {
            return (
              'http://modernizr.com/' === new URL('http://modernizr.com/').href
            )
          } catch (t) {
            return !1
          }
        })()
      )
        (n = new URL(t)).searchParams ||
          (n.searchParams =
            ((e = _.getURLSearchParams(n.search)),
            {
              get: function (t) {
                return e[t]
              }
            }))
      else {
        if (!1 === /^https?:\/\/.+/.test(t)) throw 'Invalid URL'
        var o = document.createElement('a')
        o.href = t
        for (var i = p.length - 1; i >= 0; i--) {
          var a = p[i]
          n[a] = o[a]
        }
        n.hostname &&
          'string' == typeof n.pathname &&
          0 !== n.pathname.indexOf('/') &&
          (n.pathname = '/' + n.pathname),
          (n.searchParams = (function () {
            var t = _.getURLSearchParams(n.search)
            return {
              get: function (e) {
                return t[e]
              }
            }
          })())
      }
      return n
    },
    contentLoaded: function (t, e) {
      var n = !1,
        p = !0,
        o = t.document,
        i = o.documentElement,
        a = o.addEventListener,
        r = a ? 'addEventListener' : 'attachEvent',
        s = a ? 'removeEventListener' : 'detachEvent',
        u = a ? '' : 'on',
        l = function (p) {
          ;('readystatechange' == p.type && 'complete' != o.readyState) ||
            (('load' == p.type ? t : o)[s](u + p.type, l, !1),
            !n && (n = !0) && e.call(t, p.type || p))
        },
        c = function () {
          try {
            i.doScroll('left')
          } catch (t) {
            return void setTimeout(c, 50)
          }
          l('poll')
        }
      if ('complete' == o.readyState) e.call(t, 'lazy')
      else {
        if (!a && i.doScroll) {
          try {
            p = !t.frameElement
          } catch (_) {}
          p && c()
        }
        o[r](u + 'DOMContentLoaded', l, !1),
          o[r](u + 'readystatechange', l, !1),
          t[r](u + 'load', l, !1)
      }
    },
    indexOf: function (t, e) {
      var n = t.indexOf
      if (n) return n.call(t, e)
      for (var p = 0; p < t.length; p++) if (e === t[p]) return p
      return -1
    }
  }
;(popup._ = _),
  (popup.isSupportPopup = function () {
    return _.localStorage.isSupport()
  }),
  (popup.listenPageStateChange = function () {
    var t = !0
    _.visibility({
      onVisible: function () {
        popup.log(
          '\u9875\u9762\u89e6\u53d1visible-',
          new Date().getMinutes(),
          '\u5206',
          new Date().getSeconds()
        ),
          !1 === t && (popup.updateDataAndSetListen.startState(), (t = !0))
      },
      onHidden: function () {
        popup.log(
          '\u9875\u9762\u89e6\u53d1hidden-',
          new Date().getMinutes(),
          '\u5206',
          new Date().getSeconds()
        ),
          !0 === t && (popup.updateDataAndSetListen.stopAllState(), (t = !1))
      }
    })
  }),
  (popup.getWebSDK = function () {
    return (
      !!(
        _.isObject(window.sensorsDataAnalytic201505) &&
        _.isObject(window.sensorsDataAnalytic201505.readyState) &&
        window.sensorsDataAnalytic201505.readyState.state >= 3
      ) && window.sensorsDataAnalytic201505
    )
  }),
  (popup.getPopupInfo = function (t) {
    if (!_.isObject(t) || !_.isObject(t.template)) return {}
    var e = { $sf_msg_title: '', $sf_msg_content: '', $sf_msg_image_url: '' }
    return (
      (function n(t) {
        _.each(t.subviews, function (t) {
          var p = t.properties || {}
          'title' === p.msgType
            ? (e.$sf_msg_title = p.text)
            : 'content' === p.msgType
            ? (e.$sf_msg_content = p.text)
            : 'image' === t.type && (e.$sf_msg_image_url = p.image),
            t.subviews && n(t)
        })
      })(t.template),
      e
    )
  }),
  (popup.getSFCampaign = function (t) {
    t = _.isObject(t) ? t : {}
    var e = { planId: '', name: '', content: null, type: '' }
    return (
      (e.planId = t.plan_id || ''),
      (e.name = t.cname || ''),
      (e.content = _.isObject(t.popup_window_content)
        ? t.popup_window_content.content
        : ''),
      (e.type =
        _.isObject(t.popup_window_content) && t.popup_window_content.popup_type
          ? t.popup_window_content.popup_type
          : 'PRESET'),
      e
    )
  }),
  (popup.getImageList = function (t) {
    if (!_.isArray(t)) return !1
    for (
      var e,
        n,
        p = new RegExp(
          '("(backgroundImage|image)":"(http(s)?://.[^"]*)")',
          'g'
        ),
        o = new RegExp('http(s)?://.[^S^"]*'),
        i = {},
        a = t.length,
        r = [],
        s = 0;
      s < a;
      s++
    )
      if (
        _.isObject(t[s]) &&
        'ACTIVE' === t[s].status.toLocaleUpperCase() &&
        !0 === t[s].is_audience &&
        (t[s].strategy_id
          ? !1 !== t[s].is_trigger
          : !0 !== t[s].is_control_group) &&
        t[s].popup_window_content &&
        t[s].popup_window_content.content &&
        (e = t[s].popup_window_content.content.match(p))
      )
        for (var u = 0, l = e.length; u < l; u++)
          (n = e[u].match(o)) && n.length > 0 && (i[n[0]] || (i[n[0]] = 1))
    return (
      _.each(i, function (t, e) {
        r.push(e)
      }),
      r
    )
  }),
  (popup.setIsLoad = function () {
    if (window.self === window.top) {
      if (window[popup.config.loadedSign]) return !1
      if ('undefined' == typeof window[popup.config.loadedSign])
        return (window[popup.config.loadedSign] = !0), !0
    } else
      try {
        return (
          !window.top[popup.config.loadedSign] &&
          ((window.top[popup.config.loadedSign] = !0), !0)
        )
      } catch (t) {
        return (
          popup.log(
            '\u975e\u540c\u57df\u540diframe\u5185\u5d4c\u4e0d\u80fd\u83b7\u53d6\u7236\u7ea7\u7a97\u4f53\u5185\u5bb9',
            t
          ),
          !0
        )
      }
  }),
  (popup.handlerCampaign = function (t) {
    var e,
      n = t,
      p = _.getUuid()(),
      o = n.plan.popup_window_content
    if (!_.isObject(o))
      return n.popupFailed(1001, !1, { uuid: p, content: '', plan: n.plan }), !1
    if (o.content)
      try {
        e = JSON.parse(o.content)
      } catch (u) {
        popup.log(u)
      }
    var i = popup.getSFCampaign(n.plan),
      a = { state: '', isCustom: !1 },
      r = !0
    try {
      r = popup.info.popup_campaign_listener.shouldStart(i)
    } catch (u) {
      ;(r = !1), popup.log(u)
    }
    var s = { uuid: p, content: e, plan: n.plan }
    switch (
      (n.plan.is_trigger
        ? r
          ? 'CUSTOMIZED' === o.popup_type
            ? 'withoutCampaignListener' === popup.info.supportCustom
              ? (a.state = 'CAMPAIGN_CUSTOMIZED_NULL_LISTENER')
              : 'withoutStart' === popup.info.supportCustom
              ? (a.state = 'CAMPAIGN_CUSTOMIZED_LISTENER_NULL_START')
              : _.isString(o.content)
              ? (a.state = 'CAMPAIGN_TRIGGER_CUSTOMIZED_START')
              : (a.state = 'DIALOG_NOT_SHOW_JSON_FAILED')
            : ('PRESET' === o.popup_type &&
                popup.log(
                  '\u6b64\u7248\u672csdk\u4e0d\u652f\u6301\u9884\u7f6e\u5f39\u7a97'
                ),
              (a.state = 'DIALOG_NOT_SHOW_JSON_FAILED'))
          : (a.state = 'CAMPAIGN_NOT_START_LISTENER_START')
        : (a.state = 'CAMPAIGN_NOT_START_TRIGGER'),
      (a.isCustom = !(!o.popup_type || 'CUSTOMIZED' !== o.popup_type)),
      popup.log('campaign:', a, 'plan:', n.plan.cname),
      a.state)
    ) {
      case 'CAMPAIGN_TRIGGER_CUSTOMIZED_START':
        n.customCampaign(s)
        break
      case 'CAMPAIGN_NOT_START_LISTENER_START':
        n.popupFailed(1004, a.isCustom, s)
        break
      case 'CAMPAIGN_CUSTOMIZED_NULL_LISTENER':
      case 'CAMPAIGN_CUSTOMIZED_LISTENER_NULL_START':
        n.popupFailed(1006, a.isCustom, s)
        break
      case 'DIALOG_NOT_SHOW_JSON_FAILED':
        n.popupFailed(1001, a.isCustom, s)
        break
      case 'CAMPAIGN_NOT_START_TRIGGER':
        n.popupFailed(1005, a.isCustom, s)
        break
      default:
        popup.log('CampaignState\u5f02\u5e38')
    }
  }),
  (popup.track = {
    getPublicProps: function (t) {
      var e = t.plan,
        n = {
          $sf_lib_version: popup.lib_version,
          $sf_plan_type: '\u8fd0\u8425\u8ba1\u5212',
          $sf_channel_service_name: 'SENSORS_FOCUS',
          $sf_channel_category: 'POPUP',
          $sf_platform_tag: popup.info.platform,
          $sf_msg_id: t.$sf_msg_id
        }
      return _.isEmptyObject(e) || !_.isObject(e)
        ? n
        : ((n.$sf_plan_id = e.plan_id + ''),
          (n.$sf_plan_strategy_id = e.strategy_id
            ? e.strategy_id
            : e.is_control_group
            ? '-1'
            : '0'),
          e.audience_id && (n.$sf_audience_id = e.audience_id + ''),
          e.section_id &&
            ((n.$sf_section_id = String(e.section_id)),
            (n.$sf_plan_type = '\u65b0\u8d44\u6e90\u4f4d')),
          n)
    },
    popupDisplay: function (t) {
      var e = {
        $sf_msg_title: t.$sf_msg_title,
        $sf_msg_content: t.$sf_msg_content,
        $sf_msg_image_url: t.$sf_msg_image_url,
        $sf_succeed: t.$sf_succeed,
        $sf_fail_reason: t.$sf_fail_reason
      }
      this.trackEvent('$PlanPopupDisplay', e, t)
    },
    trackEvent: function (t, e, n) {
      var p = popup.track.getPublicProps(n)
      _.extend(e, p),
        _.each(e, function (t, n) {
          ;('' !== t && t !== undefined) || delete e[n]
        }),
        popup.sa.track(t, e)
    },
    maskClick: function (t) {
      if (!t.msg) return !1
      var e = {
        $sf_close_type: 'POPUP_CLOSE_MASK',
        $sf_msg_title: t.msg.$sf_msg_title,
        $sf_msg_content: t.msg.$sf_msg_content,
        $sf_msg_image_url: t.msg.$sf_msg_image_url,
        $sf_msg_element_type: 'mask',
        $sf_msg_action_id: t.properties.maskActionId
      }
      this.trackEvent('$PlanPopupClick', e, t.msg), t.destory()
    },
    elementClickCallback: function (t, e) {
      var n = t.target,
        p = n.getAttribute('data-action'),
        o = n.getAttribute('data-info'),
        i = e.msg || {}
      if (!p) return !1
      try {
        var a = (JSON.parse(p) || {})[0],
          r = JSON.parse(o) || {}
      } catch (t) {
        popup.log('elementClickCallback error', t)
      }
      var s = {
          type: a.type,
          value: _.isString(a.value) ? a.value : '',
          extra: _.isObject(a.value) ? a.value : ''
        },
        u = e.msg.plan ? e.msg.plan.plan_id : '',
        l = {
          $sf_msg_title: i.$sf_msg_title,
          $sf_msg_content: i.$sf_msg_content,
          $sf_msg_image_url: i.$sf_msg_image_url,
          $sf_msg_element_type: r.$sf_msg_element_type,
          $sf_msg_element_content: r.$sf_msg_element_content,
          $sf_msg_element_action: a.type,
          $sf_msg_action_id: a.id,
          $sf_close_type: 'close' === a.type ? a.$sf_close_type : ''
        }
      this.trackEvent('$PlanPopupClick', l, i)
      try {
        popup.info.popup_listener.onClick(u, s)
        var c = e.msg.plan
        if (c) {
          var d = {
            name: c.cname,
            plan_id: c.plan_id,
            content: c.popup_window_content
              ? c.popup_window_content.content
              : '',
            type: c.popup_window_content
              ? c.popup_window_content.popup_type
              : '',
            action: s
          }
          popup.info.popup_campaign_listener.onClick(d)
        }
      } catch (t) {
        popup.log('popup_listener.onClick error', t)
      }
      if ('close' === a.type) e.destory()
      else if (
        (a.closeable && e.destory(),
        'auto' === popup.info.popup_listener.openlink && 'openlink' === a.type)
      ) {
        if ('http' !== a.value.slice(0, 4)) return !1
        window.location.href = a.value
      }
    }
  })
var salog = popup.log
;(popup.changeCovertStatus = function (t) {
  var e = JSON.parse(JSON.stringify(popup.convertPlans))
  _.each(e, function (e, n) {
    if (!e.is_in_convert_window) return !1
    var p = e.is_in_convert_window.step,
      o = e.is_in_convert_window.uuid
    if (
      ((popup.convertPlans[n].is_in_convert_window.step = Math.min(2 * p, 6e5)),
      !t)
    )
      return !1
    _.each(t, function (t) {
      t.popup_display_uuid === o &&
        t.convert_time &&
        (salog(
          '--\u8f6c\u5316\u7a97\u53e3- \u76ee\u6807\u4e8b\u4ef6\u5df2\u7ecf\u5b8c\u6210 - \u6ee1\u8db3',
          popup.convertPlans[n].plan_id
        ),
        delete popup.convertPlans[n].is_in_convert_window,
        popup.convertPlans.splice(n, 1))
    })
  }),
    popup.updateDataAndSetListen.updateLocalData()
}),
  (popup.asyncConvert = function (t) {
    var e = popup.info.project,
      n = !1
    if (!t && 0 === popup.convertPlans.length) return !1
    t &&
      (_.each(popup.convertPlans, function (e) {
        e.plan_id === t.plan_id && (n = !0)
      }),
      n || popup.convertPlans.push(t)),
      (function p() {
        if (
          _.isEmptyObject(popup.localData) ||
          !_.isArray(popup.convertPlans) ||
          0 === popup.convertPlans.length
        )
          return !1
        var t = JSON.parse(JSON.stringify(popup.convertPlans)),
          n =
            (t[0].is_in_convert_window && t[0].is_in_convert_window.step) ||
            5e3,
          o = []
        if (
          (_.each(t, function (t, e) {
            return (
              !!t.is_in_convert_window &&
              (new Date().getTime() > t.is_in_convert_window.expire_time
                ? (salog(
                    '--\u8f6c\u5316\u7a97\u53e3\u8d85\u65f6\u5df2\u7ecf\u8fc7\u671f - \u6ee1\u8db3',
                    popup.convertPlans[e].plan_id
                  ),
                  delete popup.convertPlans[e].is_in_convert_window,
                  popup.convertPlans.splice(e, 1),
                  popup.updateDataAndSetListen.updateLocalData(),
                  !1)
                : (o.push(t.is_in_convert_window.uuid),
                  t.is_in_convert_window.step ||
                    ((t.is_in_convert_window.step = 5e3),
                    (popup.convertPlans[e].is_in_convert_window.step = 5e3)),
                  void (
                    n > t.is_in_convert_window.step &&
                    (n = t.is_in_convert_window.step)
                  )))
            )
          }),
          !o.length)
        )
          return !1
        popup.asyncConvert.timer && clearTimeout(popup.asyncConvert.timer),
          (popup.asyncConvert.timer = setTimeout(function () {
            _.ajax({
              url:
                popup.info.api_base_url +
                '/sfo/popup_displays?project=' +
                encodeURIComponent(e) +
                '&popup_display_uuids=' +
                encodeURIComponent(o) +
                '&time=' +
                new Date().getTime(),
              type: 'GET',
              cors: !0,
              credentials: !1,
              contentType: 'application/json',
              success: function (t) {
                popup.changeCovertStatus(t), p()
              },
              error: function () {
                popup.changeCovertStatus(), p()
              }
            })
          }, n))
      })()
  }),
  (popup.ruleTime = {
    getExpire: function (t, e) {
      var n = e,
        p = Number(t.value) || 0,
        o = Number(t.value) || 0,
        i = String(t.unit).toLowerCase(),
        a = null,
        r = {
          day: function () {
            return (
              (a = new Date(n)).setHours(23),
              a.setMinutes(59),
              a.setSeconds(59),
              a.setMilliseconds(999),
              (a = a.getTime() + 864e5 * (o - 1))
            )
          },
          week: function () {
            var t = (a = new Date(n)).getDay()
            0 === t && (t = 7)
            var e = 7 - t
            return (
              a.setHours(23),
              a.setMinutes(59),
              a.setSeconds(59),
              a.setMilliseconds(999),
              (a =
                a.getTime() +
                24 * e * 60 * 60 * 1e3 +
                7 * (o - 1) * 24 * 60 * 60 * 1e3)
            )
          },
          month: function () {
            var t = (a = new Date(n)).getMonth() + o
            return (
              t >= 11
                ? (a.setFullYear(a.getFullYear() + parseInt(t / 12)),
                  a.setMonth(t % 12))
                : a.setMonth(t),
              a.setDate(1),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0),
              a.getTime()
            )
          },
          second: function (t) {
            var e = {
                month: 2592e6,
                week: 6048e5,
                day: 864e5,
                hour: 36e5,
                minute: 6e4,
                second: 1e3
              },
              o = null
            return (a = new Date(n)), t in e && (o = e[t] * p), a.getTime() + o
          }
        }
      return !0 !== t.natural ? r.second(i) : i in r ? r[i]() : void 0
    },
    getLast: function (t, e) {
      var n = Number(t.value) || 0,
        p = Number(t.value) - 1 || 0,
        o = String(t.unit).toLowerCase(),
        i = null,
        a = {
          day: function () {
            return (
              (i = new Date(e)).setHours(0),
              i.setMinutes(0),
              i.setSeconds(0),
              i.setMilliseconds(0),
              (i = i.getTime() - 864e5 * p)
            )
          },
          week: function () {
            var t = (i = new Date(e)).getDay()
            return (
              0 === t && (t = 7),
              --t,
              i.setHours(0),
              i.setMinutes(0),
              i.setSeconds(0),
              i.setMilliseconds(0),
              (i =
                i.getTime() -
                (24 * t * 60 * 60 * 1e3 + 7 * p * 24 * 60 * 60 * 1e3))
            )
          },
          month: function () {
            var t = (i = new Date(e)).getMonth() + 1 - p
            return (
              t <= 0
                ? (i.setFullYear(i.getFullYear() + (parseInt(t / 12) - 1)),
                  i.setMonth(12 + (t % 12) - 1))
                : i.setMonth(t - 1),
              i.setDate(1),
              i.setHours(0),
              i.setMinutes(0),
              i.setSeconds(0),
              i.setMilliseconds(0),
              i.getTime()
            )
          },
          second: function (t) {
            var p = {
                month: 2592e6,
                week: 6048e5,
                day: 864e5,
                hour: 36e5,
                minute: 6e4,
                second: 1e3
              },
              o = null
            return (i = new Date(e)), t in p && (o = p[t] * n), i.getTime() - o
          }
        }
      return !0 !== t.natural ? a.second(o) : o in a ? a[o]() : void 0
    },
    getArrMatchCount: function (t, e) {
      var n = 0
      for (n = 0; n < t.length; n++) if (e >= t[n]) return n
      return t.length
    }
  }),
  (popup.eventTriggerProcess = function () {
    if (!popup.updateDataAndSetListen.active_state) return !1
    if (!_.isArray(popup.localData.eventQueue)) return !1
    if (0 === popup.localData.eventQueue.length) return !1
    if (popup.isRun) return !1
    salog('\u4e8b\u4ef6\u961f\u5217---eventQueue', popup.localData.eventQueue)
    var t = !1,
      e = popup.localData.eventQueue[0],
      n = popup.eventRule[e.event]
    ;(popup.isRun = !0),
      popup.localData.eventQueue.shift(),
      popup.updateDataAndSetListen.updateLocalData(),
      _.isArray(n) &&
        _.isObject(n[0]) &&
        n.length > 0 &&
        (salog(
          '--------------------\u89e6\u53d1\u4e8b\u4ef6\u5f00\u59cb--------------------'
        ),
        _.each(n, function (t) {
          _.isObject(t) &&
            'undefined' != typeof t.match_state &&
            delete t.match_state,
            new popup.RuleCheck(t, e)
        }),
        _.each(n, function (e) {
          !0 === e.match_state
            ? !1 === t
              ? ((t = !0),
                salog(
                  '\u68c0\u67e5\u5b8c\u6bd5-\u4f18\u5148\u5f39\u7a97-\u5f00\u59cb',
                  e.plan.cname
                ),
                new popup.PopupCheck(e, !0))
              : !0 === t &&
                (salog(
                  '\u68c0\u67e5\u5b8c\u6bd5-\u975e\u4f18\u5148\u5f39\u7a97-\u4e0d\u6e32\u67d3',
                  e.plan.cname
                ),
                new popup.PopupCheck(e, !1))
            : salog(
                '\u68c0\u67e5\u5b8c\u6bd5-\u8ba1\u5212-\u4e0d\u6ee1\u8db3',
                e.plan.cname
              )
        }),
        t || popup.completeWindowLifecycle(),
        salog(
          '--------------------\u89e6\u53d1\u4e8b\u4ef6\u7ed3\u675f--------------------'
        ))
  }),
  (popup.completeWindowLifecycle = function () {
    ;(popup.isRun = !1), popup.eventTriggerProcess()
  }),
  (popup.PopupCheck = function (t, e) {
    ;(this.plan = t.plan),
      (this.current_time = new Date().getTime()),
      e ? this.renderPopup() : this.hidePopup(),
      popup.updateDataAndSetListen.updateLocalData()
  }),
  (popup.PopupCheck.prototype.createPopupWindow = function (t, e) {
    this.startConvertWindow(t),
      this.startPopupIntervalWindow(this.current_time),
      this.startPopupLimitWindow(),
      this.setGlobalLimit(),
      this.deletePlanAllWindow(),
      e && popup.completeWindowLifecycle()
  }),
  (popup.PopupCheck.prototype.hidePopup = function () {
    this.deletePlanAllWindow()
  }),
  (popup.PopupCheck.prototype.renderPopup = function () {
    popup.handlerCampaign(this)
  }),
  (popup.PopupCheck.prototype.popupFailed = function (t, e, n) {
    var p = {
        1001: '\u9884\u89c8\u4fe1\u606f\u89e3\u6790\u5931\u8d25\uff0c\u8bf7\u68c0\u67e5\u8ba1\u5212\u914d\u7f6e',
        1003: '\u5bf9\u7167\u7ec4',
        1004: 'campaignShouldStart \u63a5\u53e3\u8fd4\u56de false',
        1005: '\u8ba1\u5212\u4e0b\u53d1 is_trigger \u4e3a false',
        1006: '\u81ea\u5b9a\u4e49\u89e6\u8fbe\u8ba1\u5212\u672a\u5b9e\u73b0\u5f39\u7a97\u751f\u547d\u5468\u671f\u56de\u8c03'
      }[t],
      o = popup.getPopupInfo(n.content)
    ;(o.$sf_msg_id = n.uuid),
      (o.plan = n.plan),
      (o.$sf_succeed = !1),
      (o.$sf_fail_reason = p),
      popup.track.popupDisplay(o),
      !e &&
        popup.info.popup_listener &&
        _.isFunction(popup.info.popup_listener.onLoadFailed) &&
        popup.info.popup_listener.onLoadFailed(n.plan.plan_id, t, p),
      popup.info.popup_campaign_listener.onFailed(
        popup.getSFCampaign(n.plan),
        t,
        p
      ),
      this.createPopupWindow(n.uuid, !0)
  }),
  (popup.PopupCheck.prototype.customCampaign = function (t) {
    var e = popup.getSFCampaign(t.plan),
      n = popup.getPopupInfo(t.content)
    ;(n.$sf_msg_id = t.uuid),
      (n.plan = t.plan),
      (n.$sf_succeed = !0),
      popup.track.popupDisplay(n),
      popup.info.popup_campaign_listener.onStart(e),
      this.createPopupWindow(t.uuid, !0)
  }),
  (popup.PopupCheck.prototype.showPopup = function (t) {
    if (!popup.ElementRender)
      return popup.log('\u6682\u4e0d\u652f\u6301\u9884\u7f6e\u5f39\u7a97UI'), !1
    var e = new popup.ElementRender(t.content),
      n = popup.getPopupInfo(t.content)
    if (
      ((n.$sf_msg_id = t.uuid),
      (n.plan = t.plan),
      (n.$sf_succeed = !0),
      _.extend(e.msg, n),
      (e.popupCheckInstance = this),
      popup.track.popupDisplay(n),
      !e.render())
    )
      return (
        salog(
          '\u5f53\u524d\u9875\u9762\u5df2\u6709\u4e00\u4e2a\u5f39\u6846\u6b63\u5728\u6e32\u67d3\uff0c\u672c\u6b21\u5f39\u6846\u4e0d\u6e32\u67d3\uff01'
        ),
        !1
      )
    popup.info.popup_campaign_listener.onStart(popup.getSFCampaign(t.plan)),
      this.createPopupWindow(t.uuid),
      popup.info.popup_listener.onLoadSuccess(t.plan.plan_id)
  }),
  (popup.PopupCheck.prototype.startConvertWindow = function (t) {
    salog(
      '--\u5f39\u7a97\u5c55\u793a-\u8f6c\u5316\u7a97\u53e3\u8bbe\u7f6e',
      this.plan.cname
    ),
      _.isObject(this.plan.convert_window) &&
        this.plan.convert_window.value &&
        ((this.plan.is_in_convert_window = {
          expire_time: popup.ruleTime.getExpire(
            this.plan.convert_window,
            this.current_time
          ),
          start_time: this.current_time,
          uuid: t
        }),
        popup.asyncConvert(this.plan))
  }),
  (popup.PopupCheck.prototype.startPopupIntervalWindow = function (t) {
    _.isObject(this.plan.popup_interval) &&
      this.plan.popup_interval.value &&
      (this.plan.is_in_popup_interval_window = popup.ruleTime.getExpire(
        this.plan.popup_interval,
        t
      ))
  }),
  (popup.PopupCheck.prototype.resetPopupIntervalWindow = function () {
    var t = new Date().getTime()
    this.startPopupIntervalWindow(t),
      this.resetGlobalLimit(t),
      popup.completeWindowLifecycle()
  }),
  (popup.PopupCheck.prototype.startPopupLimitWindow = function () {
    salog(
      '--\u5f39\u7a97\u5c55\u793a-\u53c2\u4e0e\u9650\u5236\u7a97\u53e3\u8bbe\u7f6e\u91cd\u7f6e'
    ),
      _.isObject(this.plan.re_enter) &&
        this.plan.re_enter.value &&
        (_.isObject(this.plan.is_in_popup_limit_window)
          ? this.plan.is_in_popup_limit_window.count++
          : (this.plan.is_in_popup_limit_window = {
              expire_time: popup.ruleTime.getExpire(
                this.plan.re_enter,
                this.current_time
              ),
              count: 1
            }))
  }),
  (popup.PopupCheck.prototype.setGlobalLimit = function () {
    salog(
      '--\u5f39\u7a97\u5c55\u793a-\u5168\u5c40\u5f39\u7a97\u6b21\u6570\u8bbe\u7f6e'
    ),
      _.isArray(popup.localData.global_popup_count) ||
        (popup.localData.global_popup_count = []),
      popup.localData.global_popup_count.unshift(this.current_time)
    for (
      var t = popup.localData.global_popup_count, e = t[t.length - 1];
      e + 7776e6 < this.current_time || t.length > 3e3;

    )
      t.pop(), (e = t[t.length - 1])
  }),
  (popup.PopupCheck.prototype.resetGlobalLimit = function (t) {
    _.isArray(popup.localData.global_popup_count) &&
      popup.localData.global_popup_count.length > 0 &&
      (popup.localData.global_popup_count.shift(),
      popup.localData.global_popup_count.unshift(t))
  }),
  (popup.PopupCheck.prototype.deletePlanAllWindow = function () {
    var t = this.plan.pattern_popup.matcher_list
    _.isArray(t) &&
      _.each(t, function (t) {
        t.is_in_window &&
          (salog(
            '--\u5f39\u7a97\u5c55\u793a-\u91cd\u7f6e\u5404\u4e2a\u89c4\u5219\u7684\u7a97\u53e3\u8ba1\u7b97-\u6210\u529f'
          ),
          delete t.is_in_window)
      })
  }),
  (popup.RuleCheck = function (t, e) {
    ;(this.plan_match = t),
      (this.plan = t.plan),
      (this.rule_arr = t.rule),
      (this.event_data = e),
      (this.current_time = new Date().getTime())
    var n = '-------------\u68c0\u67e5-\u8ba1\u5212-(' + this.plan.cname + ')'
    _.each(this.rule_arr, function (t) {
      n +=
        '--\u5305\u542b\u89c4\u5219-(' +
        t.event_name +
        '\uff09-\u89e6\u53d1' +
        t.params[0] +
        '\u6b21'
    }),
      salog(n),
      salog(this.plan),
      this.checkPlanIsExpire(),
      popup.updateDataAndSetListen.updateLocalData()
  }),
  (popup.RuleCheck.prototype.checkPlanIsExpire = function () {
    !this.plan.expire_at ||
    (_.isNumber(this.plan.expire_at) && this.current_time < this.plan.expire_at)
      ? (salog('--\u8fc7\u671f-\u6ee1\u8db3', this.plan.cname),
        this.checkPlanIsAudience())
      : salog('--\u8fc7\u671f-\u4e0d\u6ee1\u8db3', this.plan.cname)
  }),
  (popup.RuleCheck.prototype.checkPlanIsAudience = function () {
    !0 === this.plan.is_audience
      ? (salog('--\u662f\u5426\u53d7\u4f17-\u6ee1\u8db3', this.plan.cname),
        this.checkPlanSuspend())
      : salog('--\u662f\u5426\u53d7\u4f17-\u4e0d\u6ee1\u8db3', this.plan.cname)
  }),
  (popup.RuleCheck.prototype.checkPlanSuspend = function () {
    this.plan.status && 'SUSPEND' === this.plan.status
      ? salog('--\u6682\u505c-\u4e0d\u6ee1\u8db3', this.plan.cname)
      : (salog('--\u6682\u505c-\u6ee1\u8db3', this.plan.cname),
        this.checkConvert())
  }),
  (popup.RuleCheck.prototype.checkConvert = function () {
    if (
      _.isObject(this.plan.is_in_convert_window) &&
      this.plan.is_in_convert_window.expire_time > this.current_time
    )
      salog(
        '--\u5b58\u5728\u8f6c\u5316\u7a97\u53e3 - \u4e0d\u6ee1\u8db3',
        this.plan.is_in_convert_window
      )
    else if (
      _.isObject(this.plan.is_in_convert_window) &&
      this.current_time > this.plan.is_in_convert_window.expire_time
    ) {
      salog(
        '--\u8f6c\u5316\u7a97\u53e3\u8d85\u65f6\u5df2\u7ecf\u8fc7\u671f - \u6ee1\u8db3',
        this.plan.plan_id
      ),
        delete this.plan.is_in_convert_window
      for (var t = 0; t < popup.convertPlans.length; t++)
        this.plan.plan_id === popup.convertPlans[t].plan_id &&
          (popup.convertPlans.splice(t, 1), t--)
      this.checkGlobalPopupInterval()
    } else
      salog(
        '--\u4e0d\u5b58\u5728\u8f6c\u5316\u7a97\u53e3 - \u6ee1\u8db3',
        this.plan.is_in_convert_window
      ),
        this.checkGlobalPopupInterval()
  }),
  (popup.RuleCheck.prototype.checkGlobalPopupInterval = function () {
    var t = popup.localData.global_popup_count
    if (_.isArray(t) && t.length >= 1) {
      var e = popup.ruleTime.getLast(
        popup.localData.popup_interval_global,
        this.current_time
      )
      e > t[0]
        ? (salog(
            '--\u5168\u5c40\u5f39\u7a97\u95f4\u9694-\u6ee1\u8db3-' +
              e +
              '>\u4e0a\u6b21\u5f39\u7a97\u65f6\u95f4' +
              t[0]
          ),
          this.checkPopupInterval())
        : salog(
            '\u68c0\u67e5-\u5168\u5c40\u5f39\u7a97\u95f4\u9694-\u4e0d\u6ee1\u8db3-' +
              e +
              '<\u4e0a\u6b21\u5f39\u7a97\u65f6\u95f4' +
              t[0]
          )
    } else
      salog(
        '--\u5168\u5c40\u5f39\u7a97\u95f4\u9694-\u6ca1\u6709\u5f39\u8fc7\u7a97-\u6ee1\u8db3'
      ),
        this.checkPopupInterval()
  }),
  (popup.RuleCheck.prototype.checkPopupInterval = function () {
    var t = !0
    _.isNumber(this.plan.is_in_popup_interval_window)
      ? this.current_time > this.plan.is_in_popup_interval_window
        ? (salog(
            '--\u5f39\u7a97\u95f4\u9694-\u5f53\u524d\u65f6\u95f4\u5927\u4e8e\u56fa\u5b9a\u5f39\u7a97\u95f4\u9694-\u6ee1\u8db3'
          ),
          (this.plan.is_in_popup_interval_window = null))
        : (salog(
            '--\u5f39\u7a97\u95f4\u9694-\u5f53\u524d\u65f6\u95f4\u5c0f\u4e8e\u56fa\u5b9a\u5f39\u7a97\u95f4\u9694-\u4e0d\u6ee1\u8db3'
          ),
          (t = !1))
      : (salog(
          '--\u5f39\u7a97\u95f4\u9694-\u7a97\u53e3\u4e0d\u5b58\u5728-\u65b0\u5f00'
        ),
        (this.plan.is_in_popup_interval_window = null)),
      t && this.checkPermission() && this.checkProperties()
  }),
  (popup.RuleCheck.prototype.isMatched = function (t) {
    var e = {
        equal: function (t, e) {
          if (!_.isNumber(t) && !_.isString(t)) return !1
          for (var n = 0, p = e.length; n < p; n++) {
            if (!_.isNumber(e[n]) && !_.isString(e[n])) return !1
            if (_.isString(t)) {
              if (t === (_.isString(e[n]) ? e[n] : String(e[n]))) return !0
            } else if (
              _.getConvertNumberValue(t) === _.getConvertNumberValue(e[n])
            )
              return !0
          }
          return !1
        },
        notEqual: function (t, e) {
          if (!_.isNumber(t) && !_.isString(t)) return !1
          for (var n = 0, p = e.length; n < p; n++) {
            if (!_.isNumber(e[n]) && !_.isString(e[n])) return !1
            if (_.isString(t)) {
              if (t === (_.isString(e[n]) ? e[n] : String(e[n]))) return !1
            } else if (
              _.getConvertNumberValue(t) === _.getConvertNumberValue(e[n])
            )
              return !1
          }
          return !0
        },
        contain: function (t, e) {
          return !!_.isString(t) && t.indexOf(e[0]) >= 0
        },
        notContain: function (t, e) {
          return !!_.isString(t) && -1 === t.indexOf(e[0])
        },
        isTrue: function (t) {
          return !0 === t
        },
        isFalse: function (t) {
          return !1 === t
        },
        isSet: function (t) {
          return void 0 !== t
        },
        notSet: function (t) {
          return void 0 === t
        },
        isEmpty: function (t) {
          if (!_.isString(t) && !_.isArray(t)) return !1
          if (_.isString(t)) return '' === t
          for (var e = 0; e < t.length; e++) {
            if ('' !== t[e].replace(/^\s+|\s+$/g, '')) return !1
          }
          return !0
        },
        isNotEmpty: function (t) {
          if (!_.isString(t) && !_.isArray(t)) return !1
          if (_.isString(t)) return '' !== t
          for (var e = 0; e < t.length; e++) {
            if ('' === t[e].replace(/^\s+|\s+$/g, '')) return !1
          }
          return !0
        },
        less: function (t, e) {
          return (
            !!_.isNumber(t) &&
            'undefined' != typeof e[0] &&
            _.getConvertNumberValue(t) < _.getConvertNumberValue(e[0])
          )
        },
        greater: function (t, e) {
          return (
            !!_.isNumber(t) &&
            'undefined' != typeof e[0] &&
            _.getConvertNumberValue(t) > _.getConvertNumberValue(e[0])
          )
        },
        between: function (t, e) {
          if (!_.isNumber(t)) return !1
          if ('undefined' == typeof e[0] && 'undefined' == typeof e[1])
            return !1
          var n = _.getConvertNumberValue(t),
            p = _.getConvertNumberValue(e[0]),
            o = _.getConvertNumberValue(e[1])
          return n >= p && n <= o
        },
        isIn: function (t, e) {
          if (!_.isArray(t)) return !1
          for (var n = 0; n < t.length; n++)
            if (_.indexOf(e, t[n]) >= 0) return !0
          return !1
        },
        notInclude: function (t, e) {
          if (!_.isArray(t)) return !1
          for (var n = 0; n < t.length; n++)
            if (-1 === _.indexOf(e, t[n])) return !0
          return !1
        },
        absolute_between: function (t, e) {
          try {
            var n = new Date(e[0]),
              p = new Date(e[1]),
              o = new Date(t)
            return o >= n && o <= p
          } catch (i) {
            salog('absolute_between Error', i)
          }
        },
        absoluteBetween: function (t, e) {
          try {
            var n = new Date(e[0]),
              p = new Date(e[1]),
              o = new Date(t)
            return o >= n && o <= p
          } catch (i) {
            salog('absolute_between Error', i)
          }
        }
      },
      n = this,
      p = t.relation,
      o = 'or' === String(p).toLowerCase(),
      i = 'and' === String(p).toLowerCase(),
      a = !!i,
      r = !0
    return (
      _.each(t.conditions, function (t) {
        if (!r) return !1
        if (!t.field) return !1
        var p = t.field.lastIndexOf('.'),
          s = t.params,
          u = 'in' === t['function'] ? 'isIn' : t['function']
        if (!e[u]) return (a = !1), (r = !1), !1
        if (p < 0) return !1
        var l = t.field.slice(p + 1),
          c = n.event_data.properties,
          _ = c[l]
        '$event_duration' === l && void 0 === _ && (_ = c.event_duration)
        var d = e[u](_, s)
        o && d && ((a = !0), (r = !1)), i && !d && ((a = !1), (r = !1))
      }),
      a
    )
  }),
  (popup.RuleCheck.prototype.checkProperties = function () {
    var t = this,
      e = _.filter(this.rule_arr, function (e) {
        var n = e.multi_filter ? e.multi_filter : e.filter
        return (
          !(n && (!n.conditions || 0 !== n.conditions.length)) || t.isMatched(n)
        )
      })
    _.isArray(e) && e.length > 0
      ? (this.checkWindowAndMatch(e),
        salog('--\u5c5e\u6027\u5339\u914d-\u6ee1\u8db3', e))
      : salog('--\u5c5e\u6027\u5339\u914d-\u4e0d\u6ee1\u8db3')
  }),
  (popup.RuleCheck.prototype.checkPermission = function () {
    var t = this.plan.event_permission
    if (!_.isObject(t) || _.isEmptyObject(t)) return !0
    var e = this,
      n = [],
      p = function (t) {
        return _.filter(t, function (t) {
          return (
            !(
              t &&
              t.conditions &&
              (!t.conditions || 0 !== t.conditions.length)
            ) || e.isMatched(t)
          )
        })
      }
    return (
      (function o(t) {
        _.each(t, function (t) {
          if (((n = p([t])), _.isArray(n) && n.length > 0)) {
            var e = t.filters || []
            e && e.length > 0 && o(e)
          }
        })
      })([t]),
      _.isArray(n) && n.length > 0
        ? (popup.log('--\u89d2\u8272\u5c5e\u6027\u5339\u914d-\u6ee1\u8db3', n),
          !0)
        : (popup.log(
            '--\u89d2\u8272\u5c5e\u6027\u5339\u914d-\u4e0d\u6ee1\u8db3'
          ),
          !1)
    )
  }),
  (popup.RuleCheck.prototype.checkWindowAndMatch = function (t) {
    var e = this,
      n = []
    _.each(t, function (t) {
      if (!t.params || !t.params[0])
        return (
          salog(
            '--\u7a97\u53e3\u671f\u548c\u6b21\u6570-\u89c4\u5219\u6570\u636e\u5f02\u5e38'
          ),
          !1
        )
      var p = Number(t.params[0])
      1 === p
        ? n.push(t)
        : p > 1 &&
          _.isObject(t.window) &&
          t.window.value > 0 &&
          (!_.isObject(t.is_in_window) ||
          !_.isNumber(t.is_in_window.expire_time) ||
          t.is_in_window.expire_time < e.current_time
            ? (t.is_in_window = {
                expire_time: popup.ruleTime.getExpire(t.window, e.current_time),
                count: 1
              })
            : (t.is_in_window.count = t.is_in_window.count + 1),
          t.is_in_window.count >= p
            ? n.push(t)
            : salog(
                '--\u7a97\u53e3\u671f\u548c\u6b21\u6570-\u89c4\u5219\u6570',
                t.is_in_window.count,
                '\u4e0d\u5339\u914d\u5f53\u524d\u6b21\u6570',
                p
              ))
    }),
      n.length > 0
        ? (salog(
            '--\u7a97\u53e3\u671f\u548c\u6b21\u6570-\u6709\u5339\u914d\u6210\u529f\u7684\u89c4\u5219',
            n
          ),
          this.checkGlobalPopupLimit())
        : salog(
            '--\u7a97\u53e3\u671f\u548c\u6b21\u6570-\u6ca1\u6709\u5339\u914d\u6210\u529f\u7684\u89c4\u5219',
            n
          )
  }),
  (popup.RuleCheck.prototype.checkGlobalPopupLimit = function () {
    var t = popup.localData.msg_limit_global,
      e = !0,
      n = this
    _.isObject(t) &&
    !0 === t.is_in_use &&
    _.isArray(t.limits) &&
    _.isArray(popup.localData.global_popup_count) &&
    !0 === this.plan.global_msg_limit_enabled
      ? (_.each(t.limits, function (t) {
          if (_.isObject(t) && _.isNumber(t.limit)) {
            var p = popup.ruleTime.getLast(t, n.current_time),
              o = popup.ruleTime.getArrMatchCount(
                popup.localData.global_popup_count,
                p
              )
            salog(
              '--\u5168\u5c40\u5f39\u7a97\u9650\u5236-\u5df2\u7ecf\u5f39\u7a97\u6b21\u6570-' +
                o +
                '-\u9650\u5236\u7684\u6b21\u6570' +
                t.limit +
                '-\u9650\u5236\u65f6\u95f4-' +
                p
            ),
              (e = o < t.limit ? e && !0 : e && !1)
          }
        }),
        e
          ? (salog('--\u5168\u5c40\u5f39\u7a97\u9650\u5236- \u6ee1\u8db3'),
            this.checkPopupLimit())
          : salog('--\u5168\u5c40\u5f39\u7a97\u9650\u5236-\u4e0d\u6ee1\u8db3'))
      : (salog('--\u5168\u5c40\u5f39\u7a97\u9650\u5236- \u6ee1\u8db3'),
        this.checkPopupLimit())
  }),
  (popup.RuleCheck.prototype.checkPopupLimit = function () {
    if (
      !_.isObject(this.plan.re_enter) ||
      !_.isNumber(this.plan.re_enter.value) ||
      !_.isNumber(this.plan.re_enter.limit)
    )
      return (this.plan_match.match_state = !0), !1
    _.isObject(this.plan.is_in_popup_limit_window) &&
    _.isNumber(this.plan.is_in_popup_limit_window.expire_time) &&
    _.isNumber(this.plan.is_in_popup_limit_window.count)
      ? this.plan.is_in_popup_limit_window.expire_time < this.current_time
        ? (salog(
            '--\u53c2\u4e0e\u9650\u5236-\u8d85\u8fc7\u4e86\u53c2\u4e0e\u9650\u5236\u7a97\u53e3-\u5f00\u542f\u65b0\u7a97\u53e3-\u6ee1\u8db3',
            this.plan.is_in_popup_limit_window
          ),
          delete this.plan.is_in_popup_limit_window,
          (this.plan_match.match_state = !0))
        : this.plan.is_in_popup_limit_window.count < this.plan.re_enter.limit
        ? (salog(
            '--\u53c2\u4e0e\u9650\u5236-\u5728\u7a97\u53e3\u5185\u4e14\u5728\u53c2\u4e0e\u9650\u5236\u6b21\u6570\u5185-\u6ee1\u8db3',
            this.plan.is_in_popup_limit_window
          ),
          (this.plan_match.match_state = !0))
        : salog(
            '--\u53c2\u4e0e\u9650\u5236-\u5728\u7a97\u53e3\u5185\u4f46\u662f\u8d85\u8fc7\u4e86\u53c2\u4e0e\u9650\u5236-\u4e0d\u6ee1\u8db3',
            this.plan.is_in_popup_limit_window
          )
      : (this.plan.is_in_popup_limit_window
          ? (salog(
              '--\u53c2\u4e0e\u9650\u5236-\u6709\u7a97\u53e3\u4f46\u662f\u7a97\u53e3\u6570\u636e\u5f02\u5e38-\u5f00\u65b0\u7a97\u53e3-\u6ee1\u8db3',
              this.plan.is_in_popup_limit_window
            ),
            delete this.plan.is_in_popup_limit_window)
          : salog(
              '--\u53c2\u4e0e\u9650\u5236-\u4e0d\u5b58\u5728\u7a97\u53e3-\u5f00\u65b0\u7a97\u53e3-\u6ee1\u8db3',
              this.plan.is_in_popup_limit_window
            ),
        (this.plan_match.match_state = !0))
  })
var flag_dfm = 'dfm-enc-'
function dfmapping(t) {
  var e = 't6KJCZa5pDdQ9khoEM3Tj70fbP2eLSyc4BrsYugARqFIw1mzlGNVXOHiWvxUn8',
    n = e.length - 1,
    p = {},
    o = 0
  for (o = 0; o < e.length; o++) p[e.charAt(o)] = e.charAt(n - o)
  var i = ''
  for (o = 0; o < t.length; o++)
    t.charAt(o) in p ? (i += p[t.charAt(o)]) : (i += t.charAt(o))
  return i
}
function decrypt(t) {
  return (
    0 === t.indexOf(flag_dfm) &&
      (t = dfmapping((t = t.substring(flag_dfm.length)))),
    t
  )
}
function encrypt(t) {
  return flag_dfm + dfmapping(t)
}
function initPopup() {
  if (!popup.isSupportPopup()) return !1
  if (window.screen.width && Number(window.screen.width) <= 1024)
    return (
      'object' == typeof console &&
        console.log &&
        console.log(
          'Web \u5f39\u7a97\u4ec5\u652f\u6301 PC\u7aef\uff0c\u4e14\u5c4f\u5e55\u5bbd\u5ea6\u5927\u4e8e 1024'
        ),
      !1
    )
  var t = {}
  return (
    arguments.length > 0 &&
      (1 === arguments.length && _.isObject(arguments[0])
        ? (t = arguments[0])
        : arguments.length >= 2 &&
          _.isObject(arguments[1]) &&
          (t = arguments[1])),
    !!this.setPara(t) &&
      ((popup.info.platform = 'WEB'),
      !!popup.setIsLoad() &&
        void (popup.testSend.hasParam()
          ? popup.testSend.start()
          : (popup.listenPageStateChange(),
            popup.updateDataAndSetListen.initial())))
  )
}
;(popup.store = {
  delete_time: 2592e6,
  init: function () {
    this.migrateLocalData(),
      (popup.localData = this.getLocalData()),
      _.isNumber(popup.localData.config_pull_interval_ms) &&
        popup.localData.config_pull_interval_ms > 0 &&
        (popup.updateDataAndSetListen.interval_time =
          popup.localData.config_pull_interval_ms),
      this.removeLocalData(),
      popup.log('\u521d\u59cb\u5316-\u83b7\u53d6-\u5185\u5b58-localData')
  },
  getJSONData: function () {
    var t = _.localStorage.get(popup.config.storageName)
    _.isString(t) && (t = decrypt(t))
    try {
      t = JSON.parse(t)
    } catch (e) {
      _.log(e)
    }
    return t
  },
  saveJSONData: function (t) {
    ;(t = JSON.stringify(t)),
      popup.info.encrypt_cookie && (t = encrypt(t)),
      _.localStorage.set(popup.config.storageName, t)
  },
  migrateLocalData: function () {
    var t = this.getJSONData() || {},
      e = popup.sa.store.getDistinctId()
    if (t.popup_sdk_users && t.popup_sdk_plans) return !1
    var n = { popup_sdk_plans: {}, popup_sdk_users: {} }
    ;(n.popup_sdk_plans[e] = t),
      (n.popup_sdk_users[e] = { user_id: e }),
      this.saveJSONData(n)
  },
  getLocalData: function () {
    var t = this.getJSONData(),
      e = popup.sa.store.getDistinctId(),
      n = null
    return t
      ? (_.isObject(t.popup_sdk_users[e]) &&
          t.popup_sdk_users[e].user_id &&
          (n = t.popup_sdk_users[e].user_id),
        n && _.isObject(t.popup_sdk_plans[n])
          ? ((t.popup_sdk_plans[n].update_time = new Date().getTime()),
            this.saveJSONData(t),
            t.popup_sdk_plans[n])
          : {})
      : {}
  },
  saveLocalData: function () {
    var t = this.getJSONData(),
      e = popup.sa.store.getDistinctId(),
      n = null
    if (!t) return !1
    t.popup_sdk_users &&
      _.isObject(t.popup_sdk_users[e]) &&
      t.popup_sdk_users[e].user_id &&
      ((n = t.popup_sdk_users[e].user_id),
      (t.popup_sdk_plans[n] = popup.localData),
      this.saveJSONData(t))
  },
  removeLocalData: function () {
    var t = this.getJSONData(),
      e = this.delete_time
    if (!t || !t.popup_sdk_plans || !t.popup_sdk_users) return !1
    var n = JSON.parse(JSON.stringify(t.popup_sdk_plans)),
      p = JSON.parse(JSON.stringify(t.popup_sdk_users)),
      o = new Date().getTime(),
      i = []
    _.each(n, function (n, p) {
      o - n.update_time > e && (delete t.popup_sdk_plans[p], i.push(p))
    }),
      _.each(p, function (e, n) {
        i.length > 0 &&
          _.each(i, function (p) {
            e.user_id && p === e.user_id && delete t.popup_sdk_users[n]
          })
      }),
      this.saveJSONData(t)
  }
}),
  (popup.updateDataAndSetListen = {
    active_state: !0,
    interval_time: 6e5,
    save_interval: null,
    data_interval: null,
    image_list: null,
    local_data: null,
    filterConvertPlans: function () {
      var t = popup.localData.popup_plans
      if (!t || !_.isArray(t)) return !1
      var e = _.filter(t, function (t) {
        return !!t.convert_window && !!t.is_in_convert_window
      })
      ;(popup.convertPlans = e),
        popup.log(
          '\u521d\u59cb\u5316-\u5f02\u6b65\u7684convertWindow',
          popup.convertPlans
        ),
        popup.asyncConvert()
    },
    diffData: function () {
      var t = popup.localData,
        e = JSON.parse(JSON.stringify(popup.serverData))
      new Date().getTime()
      if (!e || _.isEmptyObject(e)) return !1
      if (
        !t ||
        _.isEmptyObject(t) ||
        !t.popup_plans ||
        0 === t.popup_plans.length
      )
        return _.extend(popup.localData, e), !1
      var n = e.popup_plans
      _.each(n, function (e, p) {
        var o = null
        if (
          (_.each(t.popup_plans, function (t) {
            t.plan_id === e.plan_id &&
              ((o = t),
              e.audience_id || delete o.audience_id,
              _.isObject(e.window_update) &&
                _.each(e.window_update, function (t, n) {
                  ;(o.window_update && o.window_update[n] === t) ||
                    ('trigger_window' === n
                      ? (o.pattern_popup.matcher_list =
                          e.pattern_popup.matcher_list)
                      : 'convert_window' === n &&
                        o.is_in_convert_window &&
                        e.convert_window &&
                        o.is_in_convert_window.start_time &&
                        (o.is_in_convert_window.expire_time = popup.ruleTime.getExpire(
                          e.convert_window,
                          o.is_in_convert_window.start_time
                        )))
                }))
          }),
          !o)
        )
          return !1
        if (
          !e.window_update &&
          o.last_update_config_time !== e.last_update_config_time
        )
          return !1
        var i = o.pattern_popup.matcher_list
        _.extend2Lev(o, e), (o.pattern_popup.matcher_list = i), (n[p] = o)
      }),
        _.extend(popup.localData, e)
    },
    getEventRule: function () {
      var t = popup.localData.popup_plans,
        e = {}
      if (!t || !_.isArray(t)) return !1
      _.each(t, function (t) {
        var n = t.pattern_popup.matcher_list
        _.each(n, function (n) {
          var p = { plan: t, rule: [n] },
            o = n.event_name,
            i = !1
          if (e[o]) {
            if (
              (_.each(e[o], function (e) {
                e.plan.plan_id === t.plan_id && (e.rule.push(n), (i = !0))
              }),
              i)
            )
              return !1
            e[o].push(p)
          } else e[o] = [p]
        })
      }),
        _.each(e, function (t) {
          t.sort(function (t, e) {
            var n = e.plan.absolute_priority - t.plan.absolute_priority
            return 0 === n ? e.plan.plan_id - t.plan.plan_id : n
          })
        }),
        (popup.eventRule = e),
        popup.log(
          '\u521d\u59cb\u5316-\u5f97\u5230\u4e8b\u4ef6\u548c\u8ba1\u5212\u7684\u5173\u7cfb'
        ),
        popup.log(
          '--------------------\u521d\u59cb\u5316\u5b8c\u6210--------------------\u7b49\u5f85\u4e8b\u4ef6\u89e6\u53d1\u8ba1\u5212--------------------'
        )
    },
    registerListen: function () {
      var t = this
      popup.sa.events.on('send', function (e) {
        e.event &&
          popup.eventRule[e.event] &&
          (_.isArray(popup.localData.eventQueue) ||
            (popup.localData.eventQueue = []),
          popup.localData.eventQueue.push(e),
          t.updateLocalData(),
          popup.eventTriggerProcess())
      }),
        popup.sa.events.on('changeDistinctId', function (e) {
          t.changeId()
        }),
        popup.sa.events.isReady()
    },
    setListenEvent: function () {
      this.diffData(),
        this.filterConvertPlans(),
        this.getEventRule(),
        this.updateLocalData()
    },
    loadImage: function (t) {
      if (t.length < 1) return !1
      if (JSON.stringify(t) === JSON.stringify(this.image_list)) return !1
      this.image_list = t
      for (var e = 0; e < t.length; e++)
        (n = t[e]), void 0, (new Image().src = n)
      var n
    },
    getDataFromServer: function (t, e) {
      var n = this,
        p = encodeURIComponent(popup.sa.store.getDistinctId()),
        o = encodeURIComponent(popup.info.platform),
        i = encodeURIComponent(popup.info.project)
      ;(t = _.isFunction(t) ? t : function () {}),
        (e = _.isFunction(e) ? e : function () {}),
        _.ajax({
          url:
            popup.info.api_base_url +
            '/sfo/user_popup_configs?distinct_id=' +
            p +
            '&platform=' +
            o +
            '&project=' +
            i +
            '&time=' +
            new Date().getTime() +
            '&sdk_version=' +
            popup.lib_version,
          type: 'GET',
          cors: !0,
          credentials: !1,
          contentType: 'application/json',
          success: function (p) {
            if (!n.active_state) return e(), !1
            popup.log(
              '\u521d\u59cb\u5316-\u4fee\u6539-serverData-ajax\u83b7\u53d6'
            ),
              _.isObject(p) &&
              p.server_current_time &&
              p.popup_plans &&
              /\d+\.\d+/.test(p.min_sdk_version_required) &&
              parseFloat(p.min_sdk_version_required) <=
                parseFloat(popup.lib_version)
                ? ((popup.serverData = p),
                  _.isNumber(p.config_pull_interval_ms) &&
                    p.config_pull_interval_ms > 0 &&
                    (n.interval_time = p.config_pull_interval_ms),
                  (popup.serverData.local_update_time = new Date().getTime()),
                  popup.info.preload_image &&
                    n.loadImage(popup.getImageList(p.popup_plans)),
                  n.updateUserPlans(),
                  n.setListenEvent())
                : (popup.log(
                    '\u521d\u59cb\u5316-\u6570\u636e\u5f02\u5e38-\u8bf7\u6c42\u8fd4\u56de\u7684\u6570\u636e\u9519\u8bef-\u4e2d\u6b62'
                  ),
                  (popup.serverData = {}),
                  (popup.localData = {}),
                  n.updateLocalData()),
              t(),
              n.setIntervalTime(n.interval_time)
          },
          error: function () {
            if (!n.active_state) return e(), !1
            popup.log(
              '\u521d\u59cb\u5316-\u6570\u636e\u5f02\u5e38-\u8bf7\u6c42\u9519\u8bef-\u4e2d\u6b62'
            ),
              (popup.serverData = {}),
              t(),
              n.setIntervalTime(n.interval_time)
          }
        })
    },
    updateUserPlans: function () {
      var t = popup.store.getJSONData(),
        e = popup.sa.store.getDistinctId(),
        n = popup.serverData.user_id
      ;(t.popup_sdk_users[e] = { user_id: n || e }),
        n
          ? t.popup_sdk_plans[n]
            ? (popup.localData = t.popup_sdk_plans[n])
            : t.popup_sdk_plans[e] &&
              ((popup.localData = t.popup_sdk_plans[e]),
              delete t.popup_sdk_plans[e])
          : t.popup_sdk_plans[e] && (popup.localData = t.popup_sdk_plans[e]),
        (popup.localData.update_time = new Date().getTime()),
        popup.store.saveJSONData(t)
    },
    setIntervalTime: function (t) {
      var e = this
      this.data_interval = setTimeout(function () {
        popup.log(
          '10\u5206\u949f\u5b9a\u65f6\u66f4\u65b0\u6570\u636e\u5f00\u59cb-------'
        ),
          e.getDataFromServer()
      }, t)
    },
    setFirstListen: function () {
      var t = this
      this.getDataFromServer(function () {
        t.registerListen()
      })
    },
    updateLocalData: function () {
      var t = JSON.stringify(popup.localData)
      this.local_data !== t &&
        ((this.local_data = t), popup.store.saveLocalData())
    },
    initial: function () {
      popup.store.init()
      var t = popup.localData.local_update_time,
        e = new Date().getTime()
      if (_.isNumber(t)) {
        var n = e - t
        n <= 0 || n >= this.interval_time
          ? this.setFirstListen()
          : (this.setIntervalTime(this.interval_time - n),
            this.setListenEvent(),
            this.registerListen(),
            popup.info.preload_image &&
              this.loadImage(popup.getImageList(popup.localData.popup_plans)))
      } else this.setFirstListen()
    },
    changeId: function () {
      this.stopAllState(), this.startState({ getLocalData: !1 })
    },
    stopAllState: function () {
      ;(this.active_state = !1),
        (popup.eventRule = {}),
        this.data_interval && window.clearTimeout(this.data_interval),
        this.save_interval && window.clearInterval(this.save_interval),
        popup.asyncConvert.timer &&
          window.clearTimeout(popup.asyncConvert.timer),
        (popup.convertPlans = []),
        (popup.localData = {}),
        this.resetState()
    },
    resetState: function () {
      if ('WEB' === popup.info.platform) return !1
      !document.querySelector('div[data-sf-mask]') &&
        popup.isRun &&
        (popup.isRun = !1)
    },
    startState: function (t) {
      ;(this.active_state = !0),
        (t = t || { getLocalData: !0 }).getLocalData &&
          (this.resetState(), (popup.localData = popup.store.getLocalData())),
        this.getDataFromServer()
    }
  }),
  (popup.testSend = {
    hasParam: function () {
      var t = _.URL(window.location.href).searchParams,
        e = t.get('sf_popup_test') || '',
        n = t.get('popup_window_id') || '',
        p = t.get('platform')
      return (
        !(!e || !n) && { sf_popup_test: e, popup_window_id: n, platform: p }
      )
    },
    start: function () {
      if ('WEB' !== this.hasParam().platform)
        return (
          popup.log(
            'H5\u6d4b\u8bd5\u5f39\u7a97\u8bf7\u5728\u79fb\u52a8\u7aef\u67e5\u770b\uff01'
          ),
          !1
        )
      this.webCampaign()
    },
    webCampaign: function () {
      var t = popup.info.project,
        e = popup.info.platform,
        n = this.hasParam().popup_window_id,
        p = encodeURIComponent(popup.sa.store.getDistinctId())
      _.ajax({
        url:
          popup.info.api_base_url +
          '/sfo/popup_windows/' +
          n +
          '?project=' +
          encodeURIComponent(t) +
          '&time=' +
          new Date().getTime() +
          '&sdk_version=' +
          popup.lib_version +
          '&platform=' +
          encodeURIComponent(e) +
          '&distinct_id=' +
          p,
        type: 'GET',
        credentials: !1,
        cors: !0,
        contentType: 'application/json',
        success: function (t) {
          var e,
            n = _.getUuid()
          _.isObject(t) ||
            (popup.sa.log(
              '\u6d4b\u8bd5\u5f39\u7a97-\u670d\u52a1\u7aef\u6570\u636e\u683c\u5f0f\u4e0d\u5408\u6cd5',
              t
            ),
            (t = {}))
          try {
            e = JSON.parse(t.content)
          } catch (i) {
            popup.sa.log(
              '\u6d4b\u8bd5\u5f39\u7a97-content\u89e3\u6790\u5931\u8d25,content:',
              t,
              i
            )
          }
          var p = popup.getPopupInfo(e)
          p.$sf_msg_id = n
          var o = { content: t.content, type: t.popup_type || 'CUSTOMIZED' }
          Object.hasOwnProperty.call(t, 'name') && (o.name = t.name),
            _.isString(t.content)
              ? 'withoutCampaignListener' === popup.info.supportCustom ||
                'withoutStart' === popup.info.supportCustom
                ? ((p.$sf_succeed = !1),
                  (p.$sf_fail_reason =
                    '\u81ea\u5b9a\u4e49\u89e6\u8fbe\u8ba1\u5212\u672a\u5b9e\u73b0\u5f39\u7a97\u751f\u547d\u5468\u671f\u56de\u8c03'),
                  popup.track.popupDisplay(p),
                  popup.info.popup_campaign_listener.onFailed(
                    o,
                    1006,
                    '\u81ea\u5b9a\u4e49\u89e6\u8fbe\u8ba1\u5212\u672a\u5b9e\u73b0\u5f39\u7a97\u751f\u547d\u5468\u671f\u56de\u8c03'
                  ))
                : ((p.$sf_succeed = !0),
                  popup.track.popupDisplay(p),
                  popup.info.popup_campaign_listener.onStart(o))
              : ((p.$sf_succeed = !1),
                (p.$sf_fail_reason =
                  '\u9884\u89c8\u4fe1\u606f\u89e3\u6790\u5931\u8d25\uff0c\u8bf7\u68c0\u67e5\u8ba1\u5212\u914d\u7f6e'),
                popup.track.popupDisplay(p),
                popup.info.popup_campaign_listener.onFailed(
                  o,
                  1001,
                  '\u9884\u89c8\u4fe1\u606f\u89e3\u6790\u5931\u8d25\uff0c\u8bf7\u68c0\u67e5\u8ba1\u5212\u914d\u7f6e'
                ))
        },
        error: function (t) {
          popup.log(
            '\u6d4b\u8bd5\u5f39\u7a97\u83b7\u53d6\u6570\u636e\u9519\u8bef',
            t
          )
        }
      })
    }
  }),
  (popup.setPara = function (t) {
    _.isObject(t) || (t = {}), (popup.info = _.extend({}, popup.defaultPara, t))
    var e = popup.sa
    return e
      ? (!0 === e.para.encrypt_cookie && (popup.info.encrypt_cookie = !0),
        _.isString(popup.info.api_base_url) &&
        'http' === popup.info.api_base_url.slice(0, 4)
          ? 'http:' === popup.info.api_base_url.slice(0, 5) &&
            'https:' === location.protocol
            ? (popup.log(
                '\u60a8\u7684\u5f53\u524d\u9875\u9762\u662fhttps\u7684\u5730\u5740\uff0capi_base_url \u4e5f\u5fc5\u987b\u662fhttps\uff01'
              ),
              !1)
            : ((popup.info.api_base_url =
                '/' === popup.info.api_base_url.slice(-1)
                  ? popup.info.api_base_url.slice(0, -1)
                  : popup.info.api_base_url),
              _.isString(e.para.server_url) &&
              'http' === e.para.server_url.slice(0, 4)
                ? (popup.info.project ||
                    (popup.info.project =
                      _.URL(e.para.server_url).searchParams.get('project') ||
                      'default'),
                  (popup.info.supportCustom = !0),
                  _.isObject(popup.info.popup_campaign_listener)
                    ? (_.isFunction(
                        popup.info.popup_campaign_listener.shouldStart
                      ) ||
                        (popup.info.popup_campaign_listener.shouldStart = function () {
                          return !0
                        }),
                      _.isFunction(
                        popup.info.popup_campaign_listener.onStart
                      ) ||
                        ((popup.info.supportCustom = 'withoutStart'),
                        (popup.info.popup_campaign_listener.onStart = function () {})),
                      _.isFunction(popup.info.popup_campaign_listener.onEnd) ||
                        (popup.info.popup_campaign_listener.onEnd = function () {}),
                      _.isFunction(
                        popup.info.popup_campaign_listener.onFailed
                      ) ||
                        (popup.info.popup_campaign_listener.onFailed = function () {}),
                      _.isFunction(
                        popup.info.popup_campaign_listener.onClick
                      ) ||
                        (popup.info.popup_campaign_listener.onClick = function () {}))
                    : ((popup.info.supportCustom = 'withoutCampaignListener'),
                      (popup.info.popup_campaign_listener = {
                        shouldStart: function () {
                          return !0
                        },
                        onClick: function () {},
                        onStart: function () {},
                        onEnd: function () {},
                        onFailed: function () {}
                      })),
                  !0)
                : (popup.log(
                    'server_url \u5fc5\u987b\u586b\u5199\u6709\u6548\u6570\u636e\u63a5\u6536\u5730\u5740'
                  ),
                  !1))
          : (popup.log(
              'popup \u5fc5\u987b\u586b\u5199\u6709\u6548 api_base_url'
            ),
            !1))
      : (popup.log(
          'web js sdk \u8fd8\u6ca1\u6709\u521d\u59cb\u5316\u5b8c\u6210'
        ),
        !1)
  }),
  (popup.init = function () {
    var t = window.sensorsDataAnalytic201505
    if (
      ((popup.sa = t), (t && t.readyState && t.readyState.state >= 3) || !t.on)
    )
      initPopup.apply(this, arguments)
    else {
      var e = this,
        n = arguments
      t &&
        t.on('sdkReady', function () {
          initPopup.apply(e, n)
        })
    }
  }),
  window.SensorsDataWebJSSDKPlugin &&
  '[object Object]' ===
    Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin)
    ? (window.SensorsDataWebJSSDKPlugin.WebPopup =
        window.SensorsDataWebJSSDKPlugin.WebPopup || popup)
    : (window.SensorsDataWebJSSDKPlugin = { WebPopup: popup })
export default popup
